
<template>
  <div >
    <div class="allSet">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                  <el-tab-pane label="关于美通" name="first">
                    <aboutMT></aboutMT>
                  </el-tab-pane>
                  <el-tab-pane label="联系我们" name="second" lazy>
                    <connection></connection>
                  </el-tab-pane>
                  <el-tab-pane label="企业文化" name="third" lazy>
                    <corporateCulture></corporateCulture>
                  </el-tab-pane>
                </el-tabs>
    </div>
  </div>
</template>
<script>
import aboutMT from "./components/aboutMT.vue";
import connection from "./components/connection.vue";
import corporateCulture from "./components/corporateCulture.vue";

/**
 * Index-1 component
 */
export default {
    name:"about",
  components: {
    aboutMT,
    connection,
    corporateCulture,
  },
  created(){
    let data =JSON.parse( localStorage.getItem("inviteIndex") );
    if(data){
      this.activeName = data.activeName || 'first'
      localStorage.setItem('inviteIndex',JSON.stringify({index:0,activeName:''}));

    }
  },
  data(){
    return {
      activeName: 'first',
      activeIndex: 0, // 默认选中第一个按钮
      buttons: [
        { label: '关于美通',transportMode:'OCEAN' },
        { label: '联系我们',transportMode:'AIR' },
        { label: '企业文化',transportMode:'RAIL' },
        { label: '企业招聘',transportMode:'ROAD' }
      ],
      activePropsIndex:0,
      buttonProps: [
        { contry: '加拿大',capital:'温哥华/多伦多'},
        { contry: '美国',capital:'洛杉矶/芝加哥'}, 
        { contry: '墨西哥',capital:'墨西哥'},
        { contry: '英国',capital:'伦敦'},
        { contry: '比利时',capital:'烈日'},
        { contry: '德国',capital:'科隆'},
        { contry: '法国',capital:'巴黎'},
        { contry: '日本',capital:'大阪府'},
      ],
    }
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event);
      },
    setActive(item,index) {
      if(index === 1){
        this.$router.push({
          name:'connection'
        })
      }else if(index === 2){
        this.$router.push({
          name:'corporateCulture'
        })
      }else if(index === 3){
        this.$router.push({
          name:'inviteJob'
        })
      }else {
        this.$router.push({
          name:'about'
        })
      }
      // this.activeIndex = index;
      

    },
  }
};
</script>
<style src="./index.css" scoped></style>